import { render, staticRenderFns } from "./NewestCodesOnly.vue?vue&type=template&id=2ddcaf2a&scoped=true&"
import script from "./NewestCodesOnly.vue?vue&type=script&lang=js&"
export * from "./NewestCodesOnly.vue?vue&type=script&lang=js&"
import style0 from "./NewestCodesOnly.vue?vue&type=style&index=0&id=2ddcaf2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddcaf2a",
  null
  
)

export default component.exports